import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=03faf85b&scoped=true&"
import script from "./Cross.vue?vue&type=script&lang=ts&"
export * from "./Cross.vue?vue&type=script&lang=ts&"
import style0 from "./Cross.vue?vue&type=style&index=0&id=03faf85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03faf85b",
  null
  
)

export default component.exports